<template>
    <div>
        <div class="form-group">
            <div class="m-t-12">
                <SOInputRegular
                    :title="'Nama Layanan'"
                    :placeholder="'Nama layanan...'"
                    :validation="'alphanumeric'"
                    :required="true"
                    v-model="dataLayanan.nama_layanan"
                    @keyup="$emit('update:dataLayanan', dataLayanan)"
                />
                <ErrorMessage
                    class="error"
                    label="Nama Layanan"
                    :validation="$v.dataLayanan.nama_layanan"
                    ref="errmsg_nama_layanan"
                ></ErrorMessage>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-6 col-sm-6 col-6">
                <SOInputNominal
                    ref="harga_layanan"
                    :placeholder="'12.345'"
                    :title="'Harga'"
                    :prefix-left="true"
                    :prefix="'Rp'"
                    v-model="harga_layanan_create"
                    allowZero
                    @input="onChangeNominal($event, 'harga')"
                    @focus="onFocus"
                />
                <ErrorMessage
                    class="error"
                    label="Harga"
                    :validation="$v.dataLayanan.harga"
                    ref="errmsg_harga_layanan_create"
                ></ErrorMessage>
            </div>
            <div class="form-group col-md-6 col-sm-6 col-6">
                <SOInputSelect
                    :required="true"
                    :title="`Per`"
                    :placeholder="`Pilih Satuan`"
                    :options="optionsSatuan"
                    :selected="selectedSatuan"
                    ref="pilihSatuan"
                    @option-selected="onSelectSatuan"
                />
                <ErrorMessage
                    class="error"
                    label="Satuan"
                    :validation="$v.dataLayanan.idsatuan"
                    ref="errmsg_selected"
                ></ErrorMessage>
            </div>
        </div>
        <div>
            <label class="remove-margin f-c-midgrey f-regular f-14 require" for="phone">Durasi Pengerjaan</label>
        </div>
        <div class="row remove-padding-margin">
            <div class="col-md-6 col-sm-6 col-6 remove-padding" style="padding-right: 4px">
                <InputMinPlus
                    ref="durasi_hari_layanan"
                    v-model="dataLayanan.durasi_penyelesaian_hari"
                    :id="'hari'"
                    :minValue="0"
                    :maxValue="31"
                    :metric="'Hari'"
                />
                <ErrorMessage
                    class="error"
                    label="Durasi Pengerjaan"
                    :validation="$v.dataLayanan.durasi_penyelesaian_hari"
                    ref="errmsg_durasi_hari"
                ></ErrorMessage>
            </div>
            <div class="col-md-6 col-sm-6 col-6 remove-padding text-right" style="padding-left: 4px">
                <InputMinPlus
                    ref="durasi_jam_layanan"
                    v-model="dataLayanan.durasi_penyelesaian_jam"
                    :id="'jam'"
                    :minValue="0"
                    :maxValue="23"
                    :metric="'Jam'"
                />
                <ErrorMessage
                    class="error"
                    label="Durasi Pengerjaan"
                    :validation="$v.dataLayanan.durasi_penyelesaian_jam"
                    ref="errmsg_durasi_jam"
                ></ErrorMessage>
            </div>
        </div>
    </div>
</template>
<script>
import conn from "@/store/utils/connection";

import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import InputMinPlus from "@/component-items/InputMinPlus";
import ErrorMessage from "@/component-items/ErrorMessage";

import { minValue, minLength, required } from "vuelidate/lib/validators";

export default {
    name: "DataLayanan",
    props: {
        dataLayanan: {
            type: Object,
            required: true,
        },
        fetching: {
            type: Boolean,
            required: true,
        },
        upah: {
            type: Object,
            required: true,
        },
    },
    components: {
        SOInputRegular,
        SOInputSelect,
        SOInputNominal,
        InputMinPlus,
        ErrorMessage,
    },
    data() {
        return {
            satuan_layanan: [],
            harga_layanan_create: {
                raw: 0,
                formatted: "",
            },
            changeHarga: false,
        };
    },
    async mounted() {
        await this.initHarga();
        await this.initDurasi();
        await this.getDataSatuan();
        await this.$refs.pilihSatuan.customStyle();
        setTimeout(() => {
            this.setSatuanLayanan();
        }, 100);
    },
    watch: {
        harga: function(newVal, oldVal) {
            if (newVal !== oldVal && !this.changeHarga) {
                this.initHarga();
            }
        },
        durasiJam: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.initDurasi();
            }
        },
        durasiHari: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.initDurasi();
            }
        },
    },
    validations: {
        dataLayanan: {
            nama_layanan: {
                required,
                minLength: minLength(2),
            },
            harga: {
                // required,
                // minValue: minValue(1),
            },
            idsatuan: {
                required,
            },
            durasi_penyelesaian_jam: {
                required,
            },
            durasi_penyelesaian_hari: {
                required,
            },
        },
    },
    computed: {
        apiEndPoint: function() {
            return {
                satuan: `${this.$baseurl}/masterData/meta/satuan_meta`,
            };
        },
        harga() {
            return this.dataLayanan.harga;
        },
        durasiHari() {
            return this.dataLayanan.durasi_penyelesaian_hari;
        },
        durasiJam() {
            return this.dataLayanan.durasi_penyelesaian_jam;
        },
        selectedSatuan() {
            return this.dataLayanan.idsatuan;
        },
        optionsSatuan() {
            return this.satuan_layanan;
        },
    },
    methods: {
        errorValidate() {
            let {
                nama_layanan,
                harga,
                idsatuan,
                durasi_penyelesaian_jam,
                durasi_penyelesaian_hari,
            } = this.$v.dataLayanan;

            nama_layanan.$touch();
            harga.$touch();
            idsatuan.$touch();
            durasi_penyelesaian_jam.$touch();
            durasi_penyelesaian_hari.$touch();

            console.log(nama_layanan, harga)

            return (
                nama_layanan.$invalid ||
                harga.$invalid ||
                idsatuan.$invalid ||
                durasi_penyelesaian_jam.$invalid ||
                durasi_penyelesaian_hari.$invalid
            );
        },
        onSelectSatuan(e) {
            this.dataLayanan.idsatuan = e;
            this.setSatuanLayanan();
        },
        setSatuanLayanan() {
            let idSatuan = this.dataLayanan.idsatuan;
            let satuan = this.optionsSatuan.find((st) => st.id == idSatuan);
            this.dataLayanan.satuan = satuan.text;
        },
        setFetching(val) {
            this.$emit("update:fetching", val);
        },
        onChangeNominal(e, target) {
            this.dataLayanan[target] = e.raw;
            this.changeHarga = true;
        },
        initHarga() {
            let { harga } = this.dataLayanan;
            if (harga > 0) {
                this.harga_layanan_create.raw = harga;
                this.harga_layanan_create.formatted = harga.toString();

                this.$refs.harga_layanan.nominal.formatted = harga.toString();
                this.$refs.harga_layanan.nominal.raw = harga;
            }
        },
        onFocus() {
            Object.keys(this.upah).forEach((key) => {
                if (this.upah[key].percent.raw > 0) {
                    this.$emit("updateUpahBorongan", { key, val: this.upah[key].percent.raw });
                }
            });
        },
        initDurasi() {
            let { durasi_penyelesaian_hari, durasi_penyelesaian_jam } = this.dataLayanan;
            this.$refs.durasi_hari_layanan.val = durasi_penyelesaian_hari ? durasi_penyelesaian_hari : 0;
            this.$refs.durasi_jam_layanan.val = durasi_penyelesaian_jam ? durasi_penyelesaian_jam : 0;
        },
        async getDataSatuan() {
            this.setFetching(true);
            this.satuan_layanan = [];
            $("#loadingPage").addClass("overlayLoading");
            try {
                const response = await conn.get(this.apiEndPoint.satuan);
                if (response.status === 200) {
                    var satuans = response.data.data;
                    satuans.forEach((satuan) => {
                        this.satuan_layanan.push({
                            id: satuan.iddata_satuan,
                            text: satuan.nama,
                        });
                    });
                }
                this.setFetching(false);
                $("#loadingPage").removeClass("overlayLoading");
            } catch (e) {}
        },
        resetData() {
            this.harga_layanan_create.raw = 0;
            this.harga_layanan_create.formatted = "";

            this.dataLayanan.nama_layanan = "";
            this.dataLayanan.harga = 0;
            this.dataLayanan.idsatuan = "";
            this.dataLayanan.durasi_penyelesaian_hari = 0;
            this.dataLayanan.durasi_penyelesaian_jam = 0;

            this.$refs.errmsg_nama_layanan.resetValidation();
            this.$refs.errmsg_harga_layanan_create.resetValidation();
            this.$refs.errmsg_selected.resetValidation();
            this.$refs.errmsg_durasi_hari.resetValidation();
            this.$refs.errmsg_durasi_jam.resetValidation();

            this.$refs.inputhariref.val = 0;
            this.$refs.inputjamref.val = 0;

            this.$emit("update:dataLayanan", this.dataLayanan);
        },
    },
};
</script>
